
import { nsAccount } from '@/app/i18n/namespaces';
import CONTRACTS_ACCESS from '../../api/apiUrls';
import Entity from '@/common-utils/components/renders/entity/Entity';
import SendResetPasswords from './SendResetPasswords';

const MerchantAccountsImportProps = {
    apiUrl: CONTRACTS_ACCESS.FILE_ACTION.url,
    namespace: nsAccount,
    fileExampleProperties: {
        name: 'add_contracts_accesses_example.csv',
        path: '/static/resource/files/add_contracts_accesses_example.csv'
    },
    uploadProperties: {
        fileExtAccepted: ['.csv'],
        typeOfUpload: 'text',
        invalidFileEntity: 'modal.import.error.invalid_file',
        maxSize: 10485760
    },
    countLines: (fileData) => {
        let numberOfAccountsIgnored = 0;
        const fileLines = fileData.split('\n');
        let numberOfAccounts = 0;
        if (fileLines[0].includes('label_account;mail;contrat;application;bank_code;rank;contract_label')) {
            // At least 1 since there are headers
            numberOfAccountsIgnored = 1;
        }
        for (const line of fileLines) {
            // Don't take in count empty lines and those without labels
            if (line !== '' && line[0] !== ';') {
                numberOfAccounts = numberOfAccounts + 1;
            }
        }
        numberOfAccounts = numberOfAccounts - numberOfAccountsIgnored;
        return { numberOfLines: numberOfAccounts, file: fileData };
    },
    explanations: () => {
        return (<>
            <Entity entity='modal.import.explanations.header' namespace={nsAccount} />
            <ul className='list-disc list-outside [&_ul]:list-[revert] ml-8'>
                <li><Entity entity='modal.import.explanations.label_account' namespace={nsAccount} /></li>
                <li><Entity entity='modal.import.explanations.mail' namespace={nsAccount} /></li>
                <li><Entity entity='modal.import.explanations.contrat' namespace={nsAccount} /></li >
                <li><Entity entity='modal.import.explanations.application' namespace={nsAccount} /></li>
                <li><Entity entity='modal.import.explanations.bank_code' namespace={nsAccount} /></li>
                <li><Entity entity='modal.import.explanations.rank' namespace={nsAccount} /></li>
                <li><Entity entity='modal.import.explanations.contract_label' namespace={nsAccount} /></li>
            </ul>
            <div className='mt-4'>
                <Entity entity='modal.import.explanations.multiple_contracts' namespace={nsAccount} />
            </div>
            <div className='mt-4'>
                <Entity entity='modal.import.explanations.warning' namespace={nsAccount} />
            </div>
        </>);
    },
    confirmation: (numberOfLines) => {
        return <Entity
            entity='modal.import.confirmation'
            namespace={nsAccount}
            data={{ numberOfAccounts: numberOfLines }}
        />;
    },
    renderPostImport: (fileDetails, params) => {
        return <SendResetPasswords token={fileDetails.uuidToken} onClose={params.onClose} setPostImportActionIsLoading={params.setPostImportActionIsLoading} />;
    },
    isFileOnError: (fileDetails) => {
        return fileDetails?.errorsReport;
    },
    renderPostImportErrors: (fileDetails, error) => {
        const isCsvUploadOnError = error?.response?.data;
        if (isCsvUploadOnError) {
            const errorCode = error.response.data.errorCode;
            if (errorCode === 'BAD_FORMAT') {
                return (
                    <div>
                        <Entity entity='modal.import.error.BAD_FORMAT' namespace={nsAccount} />
                        <br />
                        <br />
                        <Entity entity='modal.import.error.get_example_file' namespace={nsAccount} />
                    </div>
                );
            }
            if (errorCode === 'TOO_MANY_RESOURCES') {
                return (
                    <Entity entity='modal.import.error.TOO_MANY_RESOURCES' namespace={nsAccount} />
                );
            }
            return (
                <Entity entity='modal.import.error.UNEXPECTED_ERROR' namespace={nsAccount} />
            );
        }

        const render = [];
        const isCsvContentOnError = fileDetails && fileDetails.errorsReport;
        if (isCsvContentOnError) {
            let key = 0;
            if (fileDetails.uuidToken) {
                render.push(<div key={key}><Entity entity='modal.import.error.error' namespace={nsAccount} /></div>);
            } else {
                render.push(<div key={key}><Entity entity='modal.import.error.no_token' namespace={nsAccount} /></div>);
            }
            key += 1;
            render.push(<br key={key} />);
            key += 1;

            const errorsReport = fileDetails.errorsReport;
            const renderErrors = [];

            Object.entries(errorsReport).forEach(errKeyAndValue => {
                // initialization
                const errorFound = errKeyAndValue[0];
                const contractsAccessesOnError = errKeyAndValue[1];

                // process
                for (const contract of contractsAccessesOnError) {
                    if (!renderErrors.find(x => x.key === contract)) {
                        // create first instance of (contract, errors)
                        renderErrors.push({ key: contract, errors: [errorFound] });
                    } else {
                        // for a given contract, fill the errorFound in its errors array
                        for (const errorObj of renderErrors) {
                            if (errorObj.key === contract) {
                                // if the error isn't already stored, store it
                                if (!errorObj.errors.find(y => y === errorFound)) {
                                    errorObj.errors.push(errorFound);
                                }
                            }
                        }
                    }
                }
            });


            renderErrors.forEach(renderErr => {
                render.push(<div key={key}>{renderErr.key}</div>);
                key += 1;
                for (const element of renderErr.errors) {
                    render.push(<div key={key}><Entity entity={`modal.import.error.${element}`} namespace={nsAccount} /></div>);
                    key += 1;
                }
            });
            render.push(<br key={key} />);
            key += 1;
            render.push(<Entity entity='modal.import.error.error_2' namespace={nsAccount} key={key} />);
        }

        return (
            <div>
                {
                    render.map((object) => { return object; })
                }
            </div>
        );
    }
};

export default MerchantAccountsImportProps;